import { useGlobalStore } from '@/stores';
import CardContent from '@components/base/card/card-content.component.tsx';
import CardHeader from '@components/base/card/card-header.component.tsx';
import { zodResolver } from '@hookform/resolvers/zod';
import { Card, Stack, TextField } from '@mui/material';
import { referenceRemarksSchema } from '@validation/reference-remarks.schema.ts';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { useTranslation } from 'react-i18next';

export function CartRemarksCard() {
  const { t } = useTranslation('cart');
  const { remarks, reference, setRemarks, setReference } = useGlobalStore();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    mode: 'onChange',
    resolver: zodResolver(referenceRemarksSchema),
    values: {
      remarks: remarks,
      reference: reference,
    },
  });

  const onSubmit = async (data: z.infer<typeof referenceRemarksSchema>) => {
    setRemarks(data.remarks);
    setReference(data.reference);
  };

  useEffect(() => {
    const subscription = watch(() => handleSubmit(onSubmit)());
    return () => subscription.unsubscribe();
  }, [remarks, reference, watch, handleSubmit]);

  return (
    <Card
      elevation={2}
      sx={{
        width: '100%',
      }}
    >
      <CardHeader title={t('remarks.title')} />
      <CardContent sx={{ width: '100%' }}>
        <Stack spacing={4}>
          <TextField
            label={t('remarks.referenceLabel')}
            sx={{ width: '100%' }}
            placeholder={t('remarks.referencePlaceholder')}
            variant="filled"
            {...register('reference')}
            error={!!errors.reference?.message}
            helperText={errors.reference?.message}
          />
          <TextField
            label={t('remarks.remarksLabel')}
            sx={{ width: '100%' }}
            placeholder={t('remarks.remarksPlaceholder')}
            multiline
            rows={3}
            variant="filled"
            {...register('remarks')}
            error={!!errors.remarks?.message}
            helperText={errors.remarks?.message}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
